import { Stack, SxProps } from "@mui/material";

interface ModuleHeaderProps {
  children: React.ReactNode;
  sx?: SxProps;
  borderless?: boolean;
}

const ModuleHeader = ({ sx, borderless, ...props }: ModuleHeaderProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        padding: "16px",
        height: "44px",
        borderBottom: (theme) =>
          borderless
            ? "none"
            : `1px solid ${theme.palette.shades.neutral[100]}`,
        ...sx,
      }}
      {...props}
    />
  );
};

export default ModuleHeader;
